var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-search"},[_c('div',{staticClass:"bb-container"},[_c('SearchBar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }